export default __webpack_public_path__ + "static/O0122-c32d9fcf37de16b4261f005c4a0b90de.png";